import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { App } from './App';
import './index.css';
import 'leaflet/dist/leaflet.css';
import { ReactKeycloakProvider } from '@react-keycloak/web'
import keycloak from './config/keycloak';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const keycloakProviderInitConfig = {
  onLoad: "check-sso",
  checkLoginIframe: false,
  silentCheckSsoRedirectUri:
        window.location.origin + "/silent-check-sso.html",
};



root.render(


  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={keycloakProviderInitConfig}
  >
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </ReactKeycloakProvider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
